import { queryOptions } from '@tanstack/react-query'
import axios from 'axios'
import { z } from 'zod'
import { parseRequestError } from '@/common/utilities.ts'

const GlobalAchievementOptionSchema = z.object({
  id: z.number(),
  code: z.string(),
  name: z.string(),
  status: z.number(),
  status_name: z.string(),
})
const GlobalAchievementOptionsRespSchema = z
  .array(GlobalAchievementOptionSchema)
  .min(0)

type GlobalAchievementOptionsResp = z.infer<
  typeof GlobalAchievementOptionsRespSchema
>
export const GetGlobalAchievementTrackingOptions = () => {
  return queryOptions({
    queryKey: ['achievement_tracking_options'],
    queryFn: async (): Promise<GlobalAchievementOptionsResp> => {
      try {
        const response = await axios.get('/global_achievement_tracking_options')
        return GlobalAchievementOptionsRespSchema.parse(response.data)
      } catch (e) {
        throw new Error(parseRequestError(e).message)
      }
    },
  })
}
